export const MIRA_UI_LABEL_KEYS = {
  'Air Cooling System': 'ui.carPart.airCoolingSystem',
  'Anti-roll Bar': 'ui.carPart.antiRollBar',
  'Assistant Suggestions': 'ui.carDiagram.filter.suggestions.label',
  Battery: 'ui.carPart.battery',
  'Center Console': 'ui.carPart.centerConsole',
  'Clutch Fluid': 'ui.carPart.clutchFluid',
  Condensator: 'ui.carPart.condensator',
  'Critical defects': 'ui.carDiagram.filter.damages.sublabel',
  Damages: 'ui.carDiagram.filter.damages.label',
  'Dashboard Bottom': 'ui.carPart.dashboardBottom',
  'Dashboard Middle Heating': 'ui.carPart.dashboardMiddleHeating',
  'Dashboard Top': 'ui.carPart.dashboardTop',
  Dimensions: 'ui.carDiagram.filter.dimensions.label',
  'Drive Shaft': 'ui.carPart.driveShaft',
  'Driver Seat': 'ui.carPart.driverSeat',
  Engine: 'ui.carDiagram.tab.engine',
  'Engine Block': 'ui.carPart.engineBlock',
  'Engine Coolant': 'ui.carPart.engineCoolant',
  'Engine Oil Reservoir': 'ui.carPart.engineOilReservoir',
  Exterior: 'ui.carDiagram.tab.exterior',
  'E-mechanics': 'ui.carDiagram.tab.electric',
  'Exhaust System': 'ui.carPart.exhaustSystem',
  Filters: 'ui.carPart.filters',
  Floor: 'ui.carPart.floor',
  'Front Bumper': 'ui.carPart.frontBumper',
  'Front Electric Engine': 'ui.carPart.frontElectricEngine',
  'Front Left Brake': 'ui.carPart.frontLeftBrake',
  'Front Left Door': 'ui.carPart.frontLeftDoor',
  'Front Left Headlight': 'ui.carPart.frontLeftHeadlight',
  'Front Left Shock Absorber': 'ui.carPart.frontLeftShockAbsorber',
  'Front Left Side Panel': 'ui.carPart.frontLeftSidePanel',
  'Front Left Sideshaft': 'ui.carPart.frontLeftSideshaft',
  'Front Left Upper Control Arm': 'ui.carPart.frontLeftUpperControlArm',
  'Front Left Wheel': 'ui.carPart.frontLeftWheel',
  'Front Right Brake': 'ui.carPart.frontRightBrake',
  'Front Right Door': 'ui.carPart.frontRightDoor',
  'Front Right Headlight': 'ui.carPart.frontRightHeadlight',
  'Front Right Shock Absorber': 'ui.carPart.frontRightShockAbsorber',
  'Front Right Side Panel': 'ui.carPart.frontRightSidePanel',
  'Front Right Sideshaft': 'ui.carPart.frontRightSideshaft',
  'Front Right Upper Control Arm': 'ui.carPart.frontRightUpperControlArm',
  'Front Right Wheel': 'ui.carPart.frontRightWheel',
  'Front Windshield': 'ui.carPart.frontWindshield',
  'Gas Tank': 'ui.carPart.gasTank',
  Grille: 'ui.carPart.grille',
  Hood: 'ui.carPart.hood',
  'Intelligent AI predictions': 'ui.carDiagram.filter.suggestions.sublabel',
  Interior: 'ui.carDiagram.tab.interior',
  'Left Middle Pillar': 'ui.carPart.leftMiddlePillar',
  Length: 'ui.carDiagram.dimension.length',
  Mechanics: 'ui.carDiagram.tab.mechanics',
  'Official measurements': 'ui.carDiagram.filter.dimensions.sublabel',
  'Passenger Seat': 'ui.carPart.passengerSeat',
  Pipes: 'ui.carPart.pipes',
  'Rear Bumper': 'ui.carPart.rearBumper',
  'Rear Differential': 'ui.carPart.rearDifferential',
  'Rear Electric Engine': 'ui.carPart.rearElectricEngine',
  'Rear Left Brake': 'ui.carPart.rearLeftBrake',
  'Rear Left Door': 'ui.carPart.rearLeftDoor',
  'Rear Left Shock Absorber': 'ui.carPart.rearLeftShockAbsorber',
  'Rear Left Side Panel': 'ui.carPart.rearLeftSidePanel',
  'Rear Left Sideshaft': 'ui.carPart.rearLeftSideshaft',
  'Rear Left Taillight': 'ui.carPart.rearLeftTaillight',
  'Rear Left Upper Control Arm': 'ui.carPart.rearLeftUpperControlArm',
  'Rear Left Wheel': 'ui.carPart.rearLeftWheel',
  'Rear Right Brake': 'ui.carPart.rearRightBrake',
  'Rear Right Door': 'ui.carPart.rearRightDoor',
  'Rear Right Shock Absorber': 'ui.carPart.rearRightShockAbsorber',
  'Rear Right Side Panel': 'ui.carPart.rearRightSidePanel',
  'Rear Right Sideshaft': 'ui.carPart.rearRightSideshaft',
  'Rear Right Taillight': 'ui.carPart.rearRightTaillight',
  'Rear Right Upper Control Arm': 'ui.carPart.rearRightUpperControlArm',
  'Rear Right Wheel': 'ui.carPart.rearRightWheel',
  'Rear Board': 'ui.carPart.rearBoard',
  'Rear Seats': 'ui.carPart.rearSeats',
  'Rear Windshield': 'ui.carPart.rearWindshield',
  'Recommended actions': 'ui.carDiagram.filter.service.sublabel',
  'Right Middle Pillar': 'ui.carPart.rightMiddlePillar',
  Roof: 'ui.carPart.roof',
  'Service Needed': 'ui.carDiagram.filter.service.label',
  'Some Part A': 'ui.carPart.somePartA',
  'Steering Bar': 'ui.carPart.steeringBar',
  'Steering Wheel': 'ui.carPart.steeringWheel',
  'Tow Bar': 'ui.carPart.towBar',
  'Torsen Differential': 'ui.carPart.torsenDifferential',
  'Torsion Bar': 'ui.carPart.torsionBar',
  'Traction Battery': 'ui.carPart.tractionBattery',
  'Traction Battery Cables': 'ui.carPart.tractionBatteryCables',
  Transmission: 'ui.carPart.transmission',
  Trunk: 'ui.carPart.trunk',
  Wheelbase: 'ui.carDiagram.dimension.wheelbase',
  Width: 'ui.carDiagram.dimension.width',
  'Windscreen Wash Fluid': 'ui.carPart.windscreenWashFluid',
} as const;

type MiraUiLabel = keyof typeof MIRA_UI_LABEL_KEYS;
type MiraUiLabelTranslationKey = (typeof MIRA_UI_LABEL_KEYS)[MiraUiLabel];

function isMiraUiLabel(label: string): label is MiraUiLabel {
  return label in MIRA_UI_LABEL_KEYS;
}

export function getMiraUiLabelTranslationKey(label: string): MiraUiLabelTranslationKey | undefined {
  if (!isMiraUiLabel(label)) {
    return undefined;
  }

  return MIRA_UI_LABEL_KEYS[label];
}
